import React from 'react';
import Stepper from '../../../../../components/Stepper';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import variables from '../../../../../utils/variables';

const CollectionStepper = (props) => {
    const steps = [variables[props.lang]['create_collection'], variables[props.lang].status];
    const icons = {
        1: null,
        2: null,
    };

    return (
        <Stepper
            activeStep={props.activeStep}
            icons={icons}
            inProgress={props.inProgress || props.signInProgress || props.broadCastInProgress || props.txHashInProgress}
            steps={steps}/>
    );
};

CollectionStepper.propTypes = {
    activeStep: PropTypes.number.isRequired,
    broadCastInProgress: PropTypes.bool.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    signInProgress: PropTypes.bool.isRequired,
    txHashInProgress: PropTypes.bool.isRequired,
};

const stateToProps = (state) => {
    return {
        activeStep: state.createAssets.createCollection.activeStep,
        broadCastInProgress: state.account.bc.broadCast.inProgress,
        inProgress: state.createAssets.nft.newCollection.inProgress,
        lang: state.language,
        signInProgress: state.account.connection.addressInProgress,
        txHashInProgress: state.account.bc.txHash.inProgress,
    };
};

export default connect(stateToProps)(CollectionStepper);
